import { Controller } from '@hotwired/stimulus';
import { postRequest } from "../../src/utils"

let modal = null
// Connects to data-controller="timetable--rearrange"
export default class extends Controller {
  static targets = ['modal', 'saveBtn', 'savingBtn', 'timeSlot'];
  // static values = {
  //   timeSlotsToUpdate: Array
  // };

  connect() {
    console.log('timetable edit time slots controller connected');
  }

  // open modal and get original lesson plan and create sortable
  openModal(){
    console.log("openModal")
    modal = new Modal(this.modalTarget);
    modal.show()
  }

  // on click of save btn, compare lesson plans before and after, then post to db, then update html
  async save(){
    let data = this.compareTimeSlots()
    console.log(data)
    this.toggleSaveBtns()
    try {
      await this.updateTimeSlots(data)
    } catch(error) {
      console.log(error)
      window.alert("Something went wrong, please try again later")
    }finally {
      this.toggleSaveBtns()
      this.closeModal()
    }
    // this.finalStudentsValue = this.getStudents()
    // this.compareStudents()
    // try {
    //   await this.updateStudents()
    // } catch(error) {
    //   console.log(error)
    //   window.alert("Something went wrong, please try again later")
    // }finally {
    //   this.toggleSaveBtns()
    //   this.closeModal()
    //   this.studentsToUpdateValue = []
    // }
  }

  // reset values, sortable and modal
  closeModal(){
    console.log("closeModal")

    this.originalTimeSlotValue = []
    this.finalTimeSlotValue = []
    modal.toggle()
  }

  toggleSaveBtns(){
        console.log("toggleSaveBtns")

    this.saveBtnTarget.classList.toggle('hidden')
    this.savingBtnTarget.classList.toggle('hidden')
  }

  // post updated lesson plans to db and receive turbostream html over the wire
  async updateTimeSlots(data){
        console.log("updated time slots post request")
    try {
      // need a new route
      console.log(data)
      let resp = await postRequest("/admin/time_slots/batch_update_time", {time_slots: data})
      let html = await resp.text()
      await Turbo.renderStreamMessage(html)
    } catch(error) {
      throw(error)
    }
  }

  //  // compare original and final time of the timeSlot.s and prepare the timeSlots that need to be updated
  compareTimeSlots(){
        console.log("get time slots")

    let timeSlotsToUpdate = []
    this.timeSlotTargets.forEach((ts) => {
        let {tsId, time} = ts.dataset
        let newTime = ts.value
        // let newTime = document.getElementById(ts.id).value

        console.log('comparing', 'id:', tsId, 'old:', time, 'new:', newTime)
        console.log('result', time == newTime)
        if (time !== newTime) timeSlotsToUpdate.push({id: tsId, time: newTime})
      })
    return timeSlotsToUpdate
  }


}
